import {
  IndustryNewsFeature,
  formatNewsType,
} from '../../../models/industry-news.model';

function industryNewsInfoPopUpContent(
  feature: mapboxgl.MapboxGeoJSONFeature
): { label: string; value: string }[] | null {
  if (feature) {
    const industryNewsFeature = feature as unknown as IndustryNewsFeature;
    const { title } = industryNewsFeature.properties;
    // newsType is the safe GeoJSON property key for the content type —
    // 'type' is a reserved GeoJSON keyword that Mapbox GL JS strips from
    // feature properties during internal serialisation.
    const newsType = (feature.properties as Record<string, unknown>)
      .newsType as string | undefined;

    // Use the formatted type as the label (e.g. 'Article', 'News') so the
    // popup renders as "Article <title>" or "News <title>".
    // Falls back to 'Industry News' when no type is present.
    const label = newsType ? formatNewsType(newsType) : 'Industry News';

    return [{ label, value: title }];
  }
  return null;
}

export default industryNewsInfoPopUpContent;
